import axios from 'axios'
import { config } from '../config'
import { getTokenStorage, setTokenStorage } from './utils'

const axiosClient = axios.create()

axiosClient.defaults.headers.common['Content-Type'] = 'application/json'
axiosClient.defaults.headers.common['Accept'] = 'application/json'

// Add the Authorization header
axiosClient.interceptors.request.use(
  (config) => {
    const accessToken = getTokenStorage('accessToken')
    if (accessToken && config.headers) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosClient.interceptors.response.use(
  (res) => {
    return res
  },
  async (err) => {
    const originalConfig = err.config

    // Access Token was expired
    if (err.response.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true
      const accessToken = getTokenStorage('accessToken')
      const refreshToken = getTokenStorage('refreshToken')
      try {
        const fetchRefreshToken = async () => {
          const resRefresh = await axios
            .post(
              config.PLAYER_REFRESH_TOKEN_API,
              {
                refreshToken: refreshToken,
              },
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((res: any) => {
              return res
            })
            .catch((err: any) => {
              return err.response
            })

          if (resRefresh.status === 200) {
            const { data } = resRefresh.data
            setTokenStorage(data)
          } else if (resRefresh.status === 401) {
            try {
              const projectId = config.PUBLISH_PROJECT_ID
              const authResponse = await axios.post(
                `${config.PLAYER_AUTH_API}`,
                { projectId: projectId },
                { headers: { 'X-API-KEY': `${config.X_API_KEY}` }, withCredentials: true }
              )
              if (authResponse?.data.statusCode === 200) {
                const authData = authResponse.data.data
                setTokenStorage(authData)
                return axiosClient(originalConfig)
              } else {
                throw new Error('Failed to re-authenticate')
              }
            } catch (err) {
              console.error('Auth API call failed')
              alert('Session has expired. Please reload.')
              return Promise.reject(err)
            }
          }
          return axiosClient(originalConfig)
        }
        const returnRefreshToken = fetchRefreshToken()
        return returnRefreshToken
      } catch (_error) {
        return Promise.reject(_error)
      }
    }

    return Promise.reject(err)
  }
)

export const getErrorMessage = (status: number | undefined) => {
  console.log('AxiosError', status)
  let message: string
  switch (status) {
    case 401:
      message = '401 Error.'
      break
    case 500:
      message = '500 Internal Server Error'
      break
    default:
      message = 'Server error.'
      break
  }
  return message
}

export default axiosClient
